import React from 'react';
import { withStyles, withTheme } from '@material-ui/core/styles';
import { compose } from 'recompose';
import Loading from '../DisplayOriented/Loading';

//mui
import IconButton from '@material-ui/core/IconButton';
import Checkbox from '@material-ui/core/Checkbox';
import InputAdornment from '@material-ui/core/InputAdornment';
import Button from '@material-ui/core/Button';
import { darken, lighten } from '@material-ui/core/styles/colorManipulator';

//inputs
import TextInput from './TextInput';
import LookupInput from './LookupInput';
import SelectInput from './SelectInput';

//services
import EscrowDevice from '../../services/DataModels/EscrowDevice';
import DeviceTransferRequest from '../../services/DataModels/DeviceTransferRequest';
import { SnackbarContext } from '../../services/ContextProviders/Snackbar';
import { AssignNestedModels, GetAll } from '../../services/CLURDUtilities';
import Auth from '../../services/Auth';

//icons
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import SearchIcon from '@material-ui/icons/Search';
import FilterListIcon from '@material-ui/icons/FilterList';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';

class TransferSelectionInput extends React.Component {
	constructor(props) {
		super(props);
		this.props = props;
		this.state = {
			page: 1,
			per_page: 5,
			total: null,
			transfers_shown: null,
			transfer_ids: [],
			transfers: [],
			filters: {
				name_like: null,
				company_id_in: null,
				tags_incall: null,
				unique_id_like: null
			},
			all_selected: false,
			formerly_all_selected: false,
			company_options: null,
			tag_options: null
		};
		this.user_company_id = Auth.currentCompany()._id;
		this.load_companies();
		this.load();
	}

	load_companies = () => {
		const params = { company_id_ne: this.user_company_id };
		GetAll("companies", params).then( (companies) => {
			let tag_options = companies.reduce( (map, company) => {
				return map;
			}, {});
			let company_options =  companies.map( (company) => ({label: company.name, value: company._id, whole: company}));
			this.setState({company_options: company_options});
		});
	}

	load = () => {
		const { page, per_page, filters, transfer_ids } = this.state;
		let valid_filters = Object.entries(filters).reduce( (map, [key, value]) => {
			if (value != null && value != '') {
				if (key == "from_company_id_in") {
					map[key] = value.map( ({value}) => value);
				} else {
					map[key] = value;
				}
			}
			return map;
		}, {});
		let params = Object.assign({ from_company_id_ne: this.user_company_id, status: "pending", page: page, per_page: per_page, page_meta: true }, valid_filters, this.props.params);
		this.load_transfers(params);
	}

	load_transfers = (params) => {
		new DeviceTransferRequest().listFromAPI(params).then( (result) => {
			let transfers = result.items;
			DeviceTransferRequest.loadRequirements(transfers).then( () => {
				this.setState( (state) => {
					state.transfers_shown = transfers;
					state.total = result.total;
					return state;
				});
			}).catch( (error) => {
				this.context.openSnackbar(error, "error");
			});
		}).catch( (error) => {
			this.context.openSnackbar(error, "error");
		});
	}

	filter_change = ({field, value}) => {
		this.setState( (state) => {
			state.filters[field] = value;
			return state;
		});
	}
	
	page_change = (difference) => {
		this.setState( (state) => {
			state.page += difference;
			state.transfers_shown = null;
			return state;
		}, this.load);
	}

	filter = () => {
		document.activeElement.blur()
		this.setState( (state) => {
			state.transfers = [];
			state.transfer_ids = [];
			state.page = 1;
			this.props.onChange([], [], state.all_selected, state.formerly_all_selected, state.filters);
			return state;
		}, this.load);
	}

	render_search = () => {
		const { classes } = this.props;
		const { filters, company_options, tag_options } = this.state;
		return (
			<div className={classes.advancedFilterContainer}>
				{this.render_company_select("from_company_id_in", "From Company")}
			</div>
		);
	}

	render_company_select = (field, label) => {
		const { classes, params } = this.props;
		const { filters, company_options } = this.state;
		let lookup_state = {
			values: filters[field],
			suggestions: company_options
		};
		let disabled = false;
		if (params && params.company_id && params.company_id !== '') {
			const company = company_options.find( ({value}) => params.company_id === value).whole;
			lookup_state = {
				values: [{label: company.name, value: params.company_id}],
				suggestions: [{label: company.name, value: company._id}]
			};
			disabled = true;
		}
		return (
			<div className={classes.advancedFilter + " " + classes.lookupWrapper}>
				<LookupInput
					disabled={disabled}
					emitChange={this.filter_change}
					priorState={lookup_state}
					label={label}
					key="account"
					field={field}
					variant="standard"
					onEnter={this.filter}
					noLabel
					placeholder="Select From Accounts"
				/>
			</div>
		);
	}

	render_filter_buttons = () => {
		const { classes } = this.props;
		return (
			<div className={classes.filterButtons}>
				<Button 
					classes={{root: classes.cancelButtonOverride}} 
					onClick={() => this.setState({filters: { 
						from_company_id_in: [],
					}}, this.load)}
					color="primary"
				>
					<span className={classes.label}>Clear Filters</span>
				</Button>
			</div>
		);
	}

	select_all = () => {
		this.setState( (state) => {
			state.all_selected = true;
			state.transfers = [];
			state.transfer_ids = [];
			return state;
		}, () => this.props.onChange(this.state.transfer_ids, this.state.transfers, true, false, this.state.filters));
	}

	deselect_all = () => {
		this.setState( (state) => {
			state.all_selected = false;
			state.formerly_all_selected = false;
			state.transfer_ids = [];
			state.transfers = [];
			return state;
		}, () => this.props.onChange(this.state.transfer_ids, this.state.transfers, false, false, this.state.filters));
	}

	render_buttons = () => {
		const { classes, single, hideFilters } = this.props;
		const { all_selected, transfers, total } = this.state;
		const icon = all_selected ? <CheckBoxIcon /> : <CheckBoxOutlineBlankIcon />;
		const text = all_selected ? "Selected" : "Select";
		let select_buttons = single ? "" : (
			<React.Fragment>
				<Button
					disabled={all_selected || total === 0}
					classes={{root: classes.selectButton}}
					onClick={this.select_all}
					color="primary"
				>
					<span className={classes.selectIcon}>{icon}</span>
					<span className={classes.label}>{text}</span>
				</Button>
				<Button
					disabled={transfers.length === 0 && all_selected === false}
					classes={{root: classes.deselectButton}}
					onClick={this.deselect_all}
					color="primary"
				>
					<span className={classes.label}>Deselect</span>
				</Button>
			</React.Fragment>
		);
		return (
			<div>
				<div className={classes.filterButtons}>
					{select_buttons}
					{!hideFilters ? this.render_filter_buttons() : ""}
				</div>
			</div>
		);
	}

	render_selection_info = () => {
		const { transfer_ids, transfers_shown, all_selected, formerly_all_selected, total } = this.state;
		const { classes } = this.props;
		if ( (transfer_ids.length === 0 && !all_selected) || transfers_shown == null) {
			return "";
		}
		if (all_selected) {
			return (
				<div className={classes.devicesSelected}>
					{total} Transfer{total > 1 ? 's' : ''} Selected.
				</div>
			);
		} else if (formerly_all_selected) {
			return (
				<div className={classes.devicesSelected}>
					{(total - transfer_ids.length)} Transfers{(total - transfer_ids.length) > 1 ? 's' : ''} Selected.
				</div>
			);
		} else {
			return (
				<div className={classes.devicesSelected}>
					{transfer_ids.length} Transfers{transfer_ids.length > 1 ? 's' : ''} Selected.
				</div>
			);
		}
	}

	render_table = () => {
		const { transfers_shown } = this.state;
		const { classes, isEscrow } = this.props;
		return (
			<div className={classes.tableContainer}>
				{this.render_headings()}
				{transfers_shown ? 
					<React.Fragment>
						<div>
							{transfers_shown.map( (transfer) => (
								this.render_row(transfer)
							))}
						</div>
						{this.render_pagination_info()}
					</React.Fragment>
					:
					this.render_table_loading()
				}
			</div>
		);
	}

	render_pagination_info = () => {
		const { transfers_shown, page, per_page, total } = this.state;
		const { classes } = this.props;
		let start = 0;
		let end = 0;
		if (transfers_shown.length !== 0) {
			start = (per_page * (page - 1)) + 1;
			end = transfers_shown.length + start - 1; 
		}
		return (
			<div className={classes.paginationContainer}>
				<div className={classes.paginationText}>
					{start} - {end} of {total}
				</div>
				<div className={classes.pageArrowsContainer}>
					<IconButton disabled={start <= 1} className={classes.pageButton} onClick={() => this.page_change(-1)} aria-label="page_left">
						<NavigateBeforeIcon />
					</IconButton>
					<IconButton disabled={end === total} className={classes.pageButton} onClick={() => this.page_change(1)} aria-label="page_right">
						<NavigateNextIcon />
					</IconButton>
				</div>
			</div>
		);
	}

	render_checkbox = (transfer) => {
		const { transfer_ids, all_selected, formerly_all_selected } = this.state;
		const { classes } = this.props;
		let checked = false;
		if (all_selected) {
			checked = true;
		} else if (formerly_all_selected) {
			checked = !Boolean(transfer_ids.find( (id) => id === transfer._id));
		} else {
			checked = Boolean(transfer_ids.find( (id) => id === transfer._id));
		}
		return (
			<CustomCheckbox
				checked={checked}
				onChange={this.handle_checkbox(transfer._id)}
				value={transfer._id}
				color={"primary"}
				className={classes.checkbox}
				inputProps={{
					'aria-label': 'selection checkbox',
				}}
			/>
		);
	}

	handle_checkbox = id => event => {
		this.setState( (state) => {
			let transfer = state.transfers_shown.find( ({_id}) => _id === id);
			if (this.props.single) {
				if (state.transfer_ids[0] === id) {
					state.transfers = [];
					state.transfer_ids = [];
				} else {
					state.transfers = [transfer];
					state.transfer_ids = [id];
				}
				return state;
			}
			if (state.all_selected) {
				state.all_selected = false;
				if (state.transfers_shown.length !== 1) {
					state.formerly_all_selected = true;
					state.transfers = [transfer];
					state.transfer_ids = [id];
				} else {
					let index = state.transfer_ids.indexOf(id);
					if (index >= 0) {
						state.transfers.splice(index, 1);
						state.transfer_ids.splice(index, 1);
					}
				}
			} else {
				let index = state.transfer_ids.indexOf(id);
				if (index >= 0) {
					state.transfers.splice(index, 1);
					state.transfer_ids.splice(index, 1);
				} else {
					state.transfers.push(transfer);
					state.transfer_ids.push(id);
				}
				if (state.formerly_all_selected) {
					state.all_selected = state.transfers.length === 0;
					if (state.all_selected) state.formerly_all_selected = false;
					if (state.transfers.length === state.total) {
						state.formerly_all_selected = false;
						state.all_selected = false;
						state.transfers = [];
						state.transfer_ids = [];
					} 
				} else {
					state.all_selected = state.transfers.length === state.total;
				}
			}
			return state;
		}, () => this.props.onChange(this.state.transfer_ids, this.state.transfers, this.state.all_selected, this.state.formerly_all_selected, this.state.filters));
	}

	render_row = (transfer) => {
		const { classes, theme } = this.props;
		const status_map = {offline: theme.palette.heartbeat.offline.main, online: theme.palette.green.main, idle: theme.palette.heartbeat.idle.main, never_reported: theme.palette.grey.main};
		return (
			<div key={transfer._id} className={classes.row + " " + classes.deviceRow}>
				<div className={classes.selectedColumn}>
					{this.render_checkbox(transfer)}
				</div>
				<div className={classes.column + " " + classes.accountColumn}>
					{transfer.status}
				</div>
				<div className={classes.column + " " + classes.nameColumn}>
					{transfer.from_company_id}
				</div>
				<div className={classes.column + " " + classes.uidColumn}>
					{transfer.to_company_id}
				</div>
			</div>
		);
	}

	render_headings = () => {
		const { classes } = this.props;
		return (
			<div className={classes.row}>
				<div className={classes.selectedColumn}>
					SELECTED
				</div>
				<div className={classes.column + " " + classes.accountColumn}>
					STATUS
				</div>
				<div className={classes.column + " " + classes.nameColumn}>
					FROM COMPANY
				</div>
				<div className={classes.column + " " + classes.uidColumn}>
					TO COMPANY
				</div>
			</div>
		);
	}

	render_table_loading = () => {
		return "";
	}

	render() {
		const { todo } = this.state;
		const { hideSearch } = this.props;
		if (todo === null) {
			return <Loading />;
		}
		return (
			<div>
				{!hideSearch ? <div>
					{this.render_search()}
				</div> : ""}
				<div>
					{this.render_buttons()}
				</div>
				{this.render_table()}
				{this.render_selection_info()}
			</div>
		)
	}

}

TransferSelectionInput.contextType = SnackbarContext;
const styles = (theme) => {
	return ({
		pageButton: {
			padding: "4px",
			color: "#8e8e93",
		},
		paginationText: {
			fontSize: "14px",
			color: "#636366",
		},
		pageButtonDisabled: {
			color: "grey",
			cursor: "unset"
		},
		paginationContainer: {
			display: "flex",
			alignItems: "center",
			justifyContent: "flex-end",
			margin: "4px 0"
		},
		filterButtons: {
			display: "flex",
		},
		filterButtonOverride: {
			marginLeft: "12px",
			borderRadius: "12px",
			fontSize: "16px",
			textTransform: "unset",
			boxShadow: "none",
			color: "white",
			backgroundColor: theme.palette.pending.main,
			'&:hover': {
				backgroundColor: darken(theme.palette.pending.main, .2),
			},
		},
		cancelButtonOverride: {
			marginLeft: "12px",
		},
		selectButton: {
		},
		deselectButton: {
			marginLeft: "12px",
		},
		label: {
			whiteSpace: "nowrap",
			overflow: "hidden",
			textOverflow: "ellipsis"
		},
		buttonIcon: {
			marginRight: "8px",
			display: "flex",
			color: "white"
		},
		selectIcon: {
			marginRight: "8px",
			display: "flex",
		},
		pageArrowsContainer: {
			marginLeft: "12px"
		},
		row: {
			display: "flex",
			alignItems: "center",
			color: "grey",
			padding: "12px 0",
			fontSize: "14px",
			borderBottom: "solid lightgrey 1px",
			boxSizing: "border-box",
			position: "relative"
		},
		deviceRow: {
			color: "black"
		},
		noAdvanced: {
			display: "flex",
			marginTop: "12px"
		},
		searchName: {
			width: "100%",
			marginRight: "12px"
		},
		advancedFilter: {
			width: "48%",
			marginRight: "12px"
		},
		lookupWrapper: {
			marginBottom: 0,
			marginTop: "auto",
		},
		advancedFilterContainer: {
			display: "flex",
			alignItems: "center",
			margin: "12px 0"
		},
		column: {
			textOverflow: "ellipsis",
			whiteSpace: "nowrap",
			overflow: "hidden",
			padding: "0 4px",
			boxSizing: "border-box",
		},
		selectedColumn: {
			width: "15%",
			textAlign: "center",
		},
		nameColumn: {
			width: "25%",
			textAlign: "left"
		},
		uidColumn: {
			width: "20%",
			textAlign: "left"
		},
		accountColumn: {
			width: "20%",
			textAlign: "left"
		},
		tagsColumn: {
			width: "20%",
			textAlign: "left"
		},
		statusDot: {
			width: "8px",
			height: "8px",
			minWidth: "8px",
			minHeight: "8px",
			maxWidth: "8px",
			maxHeight: "8px",
			borderRadius: "50%",
			display: "inline-flex",
			position: "absolute",
			left: "13.5%",
			top: "19px"
		},
		checkbox: {
			padding: 0
		},
		tableContainer: {
			marginTop: "12px"
		},
		devicesSelected: {
			color: theme.palette.pending.main,
			marginLeft: "12px",
			fontSize: "16px",
		}
	});
};

const CustomCheckbox = withStyles({
	root: {
		color: "grey",
	  '&$checked': {
		color: "#2b8deb",
	  },
	},
	checked: {},
  })(props => <Checkbox color="default" {...props} />);

export default compose(
	withStyles(styles),
	withTheme(),
)(TransferSelectionInput);
